import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../shared/theme/useColorScheme";

interface TestCompletedStyles {
  container: ICSSInJSStyle;
  header: ICSSInJSStyle;
  description: ICSSInJSStyle;
  preshareResultsButton: ICSSInJSStyle;
  postshareResultsButton: ICSSInJSStyle;
  textColor: ICSSInJSStyle;
  buttonContent: ICSSInJSStyle;
}

export const useTestCompletedStyles: () => TestCompletedStyles = () => {
  const screenHeight = document.documentElement.clientHeight;
  const { main, white, green, brand } = useFluentColorScheme();
  return {
    container: {
      background: main.background2,
      position: "relative",
      width: "100%",
      minHeight: screenHeight + "px",
      justifyContent: "center",
    },
    header: {
      width: "321px",
      height: "100%",
      color: white.foreground,
      backgroundColor: "transparent",
    },
    description: {
      width: "321px",
      height: "100%",
      color: white.foreground,
      backgroundColor: "transparent",
    },
    preshareResultsButton: {
      background: brand.background,
      width: "205px",
      height: "40px",
      color: white.foreground,
      border: `1px solid ${brand.background}`,
      borderRadius: "8px",
      padding: `${pxToRem(10)} ${pxToRem(14)} ${pxToRem(10)} ${pxToRem(14)}`,
    },
    postshareResultsButton: {
      background: "transparent",
      width: "235px",
      height: "40px",
      color: green.foreground2,
      border: `1px solid ${green.foreground2}`,
      borderRadius: "8px",
      padding: `${pxToRem(10)} ${pxToRem(14)} ${pxToRem(10)} ${pxToRem(14)}`,
    },
    textColor: {
      color: white.foreground,
    },
    buttonContent: {
      color: green.foreground2,
    },
  };
};
